var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgPlum",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a0e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5a2570"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgPlum)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 40,
    r: 60
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 40,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 170,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 170,
    r: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumCircles);
export default __webpack_public_path__ + "static/media/plum-circles.c809d619fbb1d81195fceb807178d17c.svg";
export { ForwardRef as ReactComponent };